import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Img = styled.img`
  width: 15%;
  max-width: 150px;

  @media screen and (max-width: 900px) {
    width: 15%;
  }

  @media screen and (max-width: 700px) {
    width: 20%;
  }
`;

export interface LoadingPageProps {}

export const LoadingPage: React.FC<LoadingPageProps> = ({}) => {
  return (
    <Wrapper>
      {/* <Img src="/images/loading.gif" /> */}
    </Wrapper>
  );
};
